// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"style_buttonWrapper__3bCK0"};